import { UrlConstants } from "../url.constants";
export class ApiNotesConstants {
    static URL = UrlConstants.API_V2 + "Notes";
}
